"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Note = void 0;
const NoteType_1 = require("./lib/NoteType");
class Note {
    constructor(noteType) {
        this.noteType = noteType;
    }
    get isBlank() {
        return this.noteType === NoteType_1.NoteType.Blank;
    }
    get isDon() {
        return this.noteType === NoteType_1.NoteType.Don;
    }
    get isKa() {
        return this.noteType === NoteType_1.NoteType.Ka;
    }
    get isBigDon() {
        return this.noteType === NoteType_1.NoteType.DON;
    }
    get isBigKa() {
        return this.noteType === NoteType_1.NoteType.KA;
    }
    get isDrumroll() {
        return this.noteType === NoteType_1.NoteType.Drumroll;
    }
    get isBigDrumroll() {
        return this.noteType === NoteType_1.NoteType.DRUMROLL;
    }
    get isBalloon() {
        return this.noteType === NoteType_1.NoteType.Balloon;
    }
    get isEndOfDrumroll() {
        return this.noteType === NoteType_1.NoteType.DrumrollEnd;
    }
    get isKusudama() {
        return this.noteType === NoteType_1.NoteType.Kusudama;
    }
    get isMultiDon() {
        return this.noteType === NoteType_1.NoteType.MultiDon;
    }
    get isMultiKa() {
        return this.noteType === NoteType_1.NoteType.MultiKa;
    }
    get isADLIB() {
        return this.noteType === NoteType_1.NoteType.ADLIB;
    }
    get isMeasureEnd() {
        return this.noteType === NoteType_1.NoteType.MeasureEnd;
    }
    toString() {
        return this.noteType.toString();
    }
}
exports.Note = Note;
